import CrmServiceModel from "../CrmServiceModel";

export default class ActivityModel extends CrmServiceModel {
  modelName() {
    return 'activity';
  }
  icon() {
    return 'history';
  }
  defaults() {
    return {
      id: null,
      log_name: null,
      description: null,
      subject_type: null,
      event: null,
      subject_id: null,
      causer_type: null,
      causer_id: null,
      properties: null,
      batch_uuid: null,
      created_at: null,
      updated_at: null,
      causer: null
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      log_name: (val) => (this.nullStringMutator(val)),
      description: (val) => (this.nullStringMutator(val)),
      subject_type: (val) => (this.nullStringMutator(val)),
      event: (val) => (this.nullStringMutator(val)),
      subject_id: (val) => (this.nullStringMutator(val)),
      causer_type: (val) => (this.nullStringMutator(val)),
      causer_id: (val) => (this.nullStringMutator(val)),
      properties: (val) => (this.nullObjectMutator(val)),
      batch_uuid: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      causer: (val) => (this.nullStringMutator(val)),
    }
  }
}